export default __webpack_public_path__ + "static/media/Abyssal Slicer.80cb478e.jpg";